import { createStructuredSelector } from 'reselect'

import {
  SEARCH_GEO_COUNTRY,
  SEARCH_GEO_COUNTRY_SUCCESS,
  SEARCH_GEO_COUNTRY_ERROR,
  SEARCH_ENTERPRISE_TYPE,
  SEARCH_ENTERPRISE_TYPE_SUCCESS,
  SEARCH_ENTERPRISE_TYPE_ERROR,
  SEARCH_ENTERPRISE_SECTOR,
  SEARCH_ENTERPRISE_SECTOR_SUCCESS,
  SEARCH_ENTERPRISE_SECTOR_ERROR,
  SEARCH_ENTERPRISE_CATEGORY,
  SEARCH_ENTERPRISE_CATEGORY_SUCCESS,
  SEARCH_ENTERPRISE_CATEGORY_ERROR,
  SEARCH_PRODUCT_TYPE,
  SEARCH_PRODUCT_TYPE_SUCCESS,
  SEARCH_PRODUCT_TYPE_ERROR,
  SEARCH_DELIVERY_TERM,
  SEARCH_DELIVERY_TERM_SUCCESS,
  SEARCH_DELIVERY_TERM_ERROR,
  SEARCH_ARTICLE_GROUP,
  SEARCH_ARTICLE_GROUP_SUCCESS,
  SEARCH_ARTICLE_GROUP_ERROR,
  SEARCH_CURRENCY,
  SEARCH_CURRENCY_SUCCESS,
  SEARCH_CURRENCY_ERROR,
  SEARCH_QUOTE_EXPIRATION,
  SEARCH_QUOTE_EXPIRATION_SUCCESS,
  SEARCH_QUOTE_EXPIRATION_ERROR,
  SEARCH_INCOTERM,
  SEARCH_INCOTERM_SUCCESS,
  SEARCH_INCOTERM_ERROR,
  SEARCH_TRANSPORT_TYPE,
  SEARCH_TRANSPORT_TYPE_SUCCESS,
  SEARCH_TRANSPORT_TYPE_ERROR,
  SEARCH_FILE_TYPE,
  SEARCH_FILE_TYPE_SUCCESS,
  SEARCH_FILE_TYPE_ERROR,
  SEARCH_REQUEST_PROCESS_TYPE,
  SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  SEARCH_REQUEST_ARTICLE_TYPE,
  SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS,
  SEARCH_REQUEST_ARTICLE_TYPE_ERROR,
  SEARCH_HEALTH_REGISTRY_AGENCY,
  SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  SEARCH_BMP_AGENCY,
  SEARCH_BMP_AGENCY_SUCCESS,
  SEARCH_BMP_AGENCY_ERROR,
  SEARCH_RISK_TYPE,
  SEARCH_RISK_TYPE_SUCCESS,
  SEARCH_RISK_TYPE_ERROR,
  SEARCH_GHTF,
  SEARCH_GHTF_SUCCESS,
  SEARCH_GHTF_ERROR,
  SEARCH_DIAGNOSTIC_CLASS,
  SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  SEARCH_DIAGNOSTIC_CLASS_ERROR,
  SEARCH_ISO,
  SEARCH_ISO_SUCCESS,
  SEARCH_ISO_ERROR,
  SEARCH_GT_CERTIFICATE,
  SEARCH_GT_CERTIFICATE_SUCCESS,
  SEARCH_GT_CERTIFICATE_ERROR,
  SEARCH_SERVICE_TYPE,
  SEARCH_SERVICE_TYPE_SUCCESS,
  SEARCH_SERVICE_TYPE_ERROR,
  SEARCH_BIOEQUIVALENCE,
  SEARCH_BIOEQUIVALENCE_SUCCESS,
  SEARCH_BIOEQUIVALENCE_ERROR,
  SEARCH_GREEN_CERTIFICATE,
  SEARCH_GREEN_CERTIFICATE_SUCCESS,
  SEARCH_GREEN_CERTIFICATE_ERROR,
  SEARCH_ECO,
  SEARCH_ECO_SUCCESS,
  SEARCH_ECO_ERROR
} from '../actions';

export const NAME = 'search';


export const SearchGeoCountry = (data) => ({
  type: SEARCH_GEO_COUNTRY,
  payload: data
});

export const SearchGeoCountrySuccess = (data) => ({
  type: SEARCH_GEO_COUNTRY_SUCCESS,
  payload: data
});

export const SearchGeoCountryError = (error) => ({
  type: SEARCH_GEO_COUNTRY_ERROR,
  payload: error
});

export const SearchEnterpriseType = (data) => ({
  type: SEARCH_ENTERPRISE_TYPE,
  payload: data
});

export const SearchEnterpriseTypeSuccess = (data) => ({
  type: SEARCH_ENTERPRISE_TYPE_SUCCESS,
  payload: data
});

export const SearchEnterpriseTypeError = (error) => ({
  type: SEARCH_ENTERPRISE_TYPE_ERROR,
  payload: error
});

export const SearchEnterpriseSector = (data) => ({
  type: SEARCH_ENTERPRISE_SECTOR,
  payload: data
});

export const SearchEnterpriseSectorSuccess = (data) => ({
  type: SEARCH_ENTERPRISE_SECTOR_SUCCESS,
  payload: data
});

export const SearchEnterpriseSectorError = (error) => ({
  type: SEARCH_ENTERPRISE_SECTOR_ERROR,
  payload: error
});

export const SearchEnterpriseCategory = (data) => ({
  type: SEARCH_ENTERPRISE_CATEGORY,
  payload: data
});

export const SearchEnterpriseCategorySuccess = (data) => ({
  type: SEARCH_ENTERPRISE_CATEGORY_SUCCESS,
  payload: data
});

export const SearchEnterpriseCategoryError = (error) => ({
  type: SEARCH_ENTERPRISE_CATEGORY_ERROR,
  payload: error
});

export const SearchProductType = (filters) => ({
  type: SEARCH_PRODUCT_TYPE,
  payload: {filters: filters}
}); 

export const SearchProductTypeSuccess = (data) => ({
  type: SEARCH_PRODUCT_TYPE_SUCCESS,
  payload: data
});

export const SearchProductTypeError = (error) => ({
  type: SEARCH_PRODUCT_TYPE_ERROR,
  payload: error
});

export const SearchDeliveryTerm = () => ({
  type: SEARCH_DELIVERY_TERM
});

export const SearchDeliveryTermSuccess = (data) => ({
  type: SEARCH_DELIVERY_TERM_SUCCESS,
  payload: data
});

export const SearchDeliveryTermError = (error) => ({
  type: SEARCH_DELIVERY_TERM_ERROR,
  payload: error
});

export const SearchCurrency = () => ({
  type: SEARCH_CURRENCY
});

export const SearchCurrencySuccess = (data) => ({
  type: SEARCH_CURRENCY_SUCCESS,
  payload: data
});

export const SearchCurrencyError = (error) => ({
  type: SEARCH_CURRENCY_ERROR,
  payload: error
});

export const SearchArticleGroup = () => ({
  type: SEARCH_ARTICLE_GROUP
});

export const SearchArticleGroupSuccess = (data) => ({
  type: SEARCH_ARTICLE_GROUP_SUCCESS,
  payload: data
});

export const SearchArticleGroupError = (error) => ({
  type: SEARCH_ARTICLE_GROUP_ERROR,
  payload: error
});

export const SearchQuoteExpiration = () => ({
  type: SEARCH_QUOTE_EXPIRATION
});

export const SearchQuoteExpirationSuccess = (data) => ({
  type: SEARCH_QUOTE_EXPIRATION_SUCCESS,
  payload: data
});

export const SearchQuoteExpirationError = (error) => ({
  type: SEARCH_QUOTE_EXPIRATION_ERROR,
  payload: error
});

export const SearchIncoterm = () => ({
  type: SEARCH_INCOTERM
});

export const SearchIncotermSuccess = (data) => ({
  type: SEARCH_INCOTERM_SUCCESS,
  payload: data
});

export const SearchIncotermError = (error) => ({
  type: SEARCH_INCOTERM_ERROR,
  payload: error
});

export const SearchTransportType = () => ({
  type: SEARCH_TRANSPORT_TYPE
});

export const SearchTransportTypeSuccess = (data) => ({
  type: SEARCH_TRANSPORT_TYPE_SUCCESS,
  payload: data
});

export const SearchTransportTypeError = (error) => ({
  type: SEARCH_TRANSPORT_TYPE_ERROR,
  payload: error
});

export const SearchFileType = (data) => ({
  type: SEARCH_FILE_TYPE,
  payload: data
});

export const SearchFileTypeSuccess = (data) => ({
  type: SEARCH_FILE_TYPE_SUCCESS,
  payload: data
});

export const SearchFileTypeError = (error) => ({
  type: SEARCH_FILE_TYPE_ERROR,
  payload: error
});

export const SearchRequestProcessType = (data) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE,
  payload: data
});

export const SearchRequestProcessTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestProcessTypeError = (error) => ({
  type: SEARCH_REQUEST_PROCESS_TYPE_ERROR,
  payload: error
});

export const SearchRequestArticleType = (data) => ({
  type: SEARCH_REQUEST_ARTICLE_TYPE,
  payload: data
});

export const SearchRequestArticleTypeSuccess = (data) => ({
  type: SEARCH_REQUEST_ARTICLE_TYPE_SUCCESS,
  payload: data
});

export const SearchRequestArticleTypeError = (error) => ({
  type: SEARCH_REQUEST_ARTICLE_TYPE_ERROR,
  payload: error
});

export const SearchHealthRegistryAgency = (data) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY,
  payload: data
});

export const SearchHealthRegistryAgencySuccess = (data) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY_SUCCESS,
  payload: data
});

export const SearchHealthRegistryAgencyError = (error) => ({
  type: SEARCH_HEALTH_REGISTRY_AGENCY_ERROR,
  payload: error
});

export const SearchBmpAgency = (data) => ({
  type: SEARCH_BMP_AGENCY,
  payload: data
});

export const SearchBmpAgencySuccess = (data) => ({
  type: SEARCH_BMP_AGENCY_SUCCESS,
  payload: data
});

export const SearchBmpAgencyError = (error) => ({
  type: SEARCH_BMP_AGENCY_ERROR,
  payload: error
});

export const SearchRiskType = (data) => ({
  type: SEARCH_RISK_TYPE,
  payload: data
});

export const SearchRiskTypeSuccess = (data) => ({
  type: SEARCH_RISK_TYPE_SUCCESS,
  payload: data
});

export const SearchRiskTypeError = (error) => ({
  type: SEARCH_RISK_TYPE_ERROR,
  payload: error
});

export const SearchGhtf = (data) => ({
  type: SEARCH_GHTF,
  payload: data
});

export const SearchGhtfSuccess = (data) => ({
  type: SEARCH_GHTF_SUCCESS,
  payload: data
});

export const SearchGhtfError = (error) => ({
  type: SEARCH_GHTF_ERROR,
  payload: error
});

export const SearchDiagnosticClass = (data) => ({
  type: SEARCH_DIAGNOSTIC_CLASS,
  payload: data
});

export const SearchDiagnosticClassSuccess = (data) => ({
  type: SEARCH_DIAGNOSTIC_CLASS_SUCCESS,
  payload: data
});

export const SearchDiagnosticClassError = (error) => ({
  type: SEARCH_DIAGNOSTIC_CLASS_ERROR,
  payload: error
});

export const SearchIso = (data) => ({
  type: SEARCH_ISO,
  payload: data
});

export const SearchIsoSuccess = (data) => ({
  type: SEARCH_ISO_SUCCESS,
  payload: data
});

export const SearchIsoError = (error) => ({
  type: SEARCH_ISO_ERROR,
  payload: error
});

export const SearchGtCertificate = (data) => ({
  type: SEARCH_GT_CERTIFICATE,
  payload: data
});

export const SearchGtCertificateSuccess = (data) => ({
  type: SEARCH_GT_CERTIFICATE_SUCCESS,
  payload: data
});

export const SearchGtCertificateError = (error) => ({
  type: SEARCH_GT_CERTIFICATE_ERROR,
  payload: error
});

export const SearchServiceType = (data) => ({
  type: SEARCH_SERVICE_TYPE,
  payload: data
});

export const SearchServiceTypeSuccess = (data) => ({
  type: SEARCH_SERVICE_TYPE_SUCCESS,
  payload: data
});

export const SearchServiceTypeError = (error) => ({
  type: SEARCH_SERVICE_TYPE_ERROR,
  payload: error
});

export const SearchBioequivalence = (data) => ({
  type: SEARCH_BIOEQUIVALENCE,
  payload: data
});

export const SearchBioequivalenceSuccess = (data) => ({
  type: SEARCH_BIOEQUIVALENCE_SUCCESS,
  payload: data
});

export const SearchBioequivalenceError = (error) => ({
  type: SEARCH_BIOEQUIVALENCE_ERROR,
  payload: error
});

export const SearchGreenCertificate = (data) => ({
  type: SEARCH_GREEN_CERTIFICATE,
  payload: data
});

export const SearchGreenCertificateSuccess = (data) => ({
  type: SEARCH_GREEN_CERTIFICATE_SUCCESS,
  payload: data
});

export const SearchGreenCertificateError = (error) => ({
  type: SEARCH_GREEN_CERTIFICATE_ERROR,
  payload: error
});

export const SearchEco = (data) => ({
  type: SEARCH_ECO,
  payload: data
});

export const SearchEcoSuccess = (data) => ({
  type: SEARCH_ECO_SUCCESS,
  payload: data
});

export const SearchEcoError = (error) => ({
  type: SEARCH_ECO_ERROR,
  payload: error
});

const search = (state) => state[NAME];

export const SearchSelector = createStructuredSelector({
  search
})
